export default "__VITE_ASSET__281d8e98__"